(function () {
    var root = document.querySelector('[data-bulkforce]');

    if (!root) {
        return;
    }

    var toggle = root.querySelector('[data-bulkforce-toggle]');
    var panel = root.querySelector('[data-bulkforce-panel]');
    var closeButton = root.querySelector('[data-bulkforce-close]');
    var log = root.querySelector('[data-bulkforce-log]');
    var form = root.querySelector('[data-bulkforce-form]');
    var input = root.querySelector('[data-bulkforce-input]');

    if (!toggle || !panel || !log || !form || !input) {
        return;
    }

    var GREETING = 'Bulkforce online. Wanna know the community narrative? Just ask.';
    var FALLBACK = 'Bulkforce is rebulkifying. Ask again in a moment, ok?';
    var BLOCKED_GREETING = 'You know what you did. The blacklist remembers.';
    var BLOCKED_NOTICE = 'access revoked: blacklisted for language. Reddington has been notified.';
    var BLOCKED_STATUS = 'blacklisted';

    var STATUSES = [
        'fully bulkified',
        'always right',
        'laying you off',
        'claudeforce you deserve'
    ];

    var statusEl = root.querySelector('[data-bulkforce-status]');
    var lastStatus = -1;

    var greeted = false;
    var replying = false;
    var hideTimer = null;
    var blocked = false;
    var blockedNotice = null;

    function applyBlockedState() {
        blocked = true;
        root.classList.add('is-blocked');
        input.disabled = true;
        input.value = '';

        if (!blockedNotice) {
            blockedNotice = document.createElement('p');
            blockedNotice.className = 'bulkforce__blocked';
            blockedNotice.textContent = BLOCKED_NOTICE;
            panel.appendChild(blockedNotice);
        }

        if (statusEl) {
            statusEl.textContent = 'status: ' + BLOCKED_STATUS;
        }
    }

    function pickStatus() {
        if (!statusEl) {
            return;
        }

        if (blocked) {
            statusEl.textContent = 'status: ' + BLOCKED_STATUS;
            return;
        }

        var index;

        do {
            index = Math.floor(Math.random() * STATUSES.length);
        } while (STATUSES.length > 1 && index === lastStatus);

        lastStatus = index;
        statusEl.textContent = 'status: ' + STATUSES[index];
    }

    function scrollLog() {
        log.scrollTop = log.scrollHeight;
    }

    function appendUserMessage(text) {
        var message = document.createElement('div');
        message.className = 'bulkforce__msg bulkforce__msg--user';
        message.textContent = text;
        log.appendChild(message);
        scrollLog();
    }

    function appendBotMessage(reply) {
        var message = document.createElement('div');
        message.className = 'bulkforce__msg bulkforce__msg--bot';
        var lines = typeof reply === 'string' ? [reply] : reply.lines;

        for (var i = 0; i < lines.length; i += 1) {
            var line = document.createElement('p');
            line.textContent = lines[i];
            message.appendChild(line);
        }

        if (typeof reply !== 'string' && reply.link) {
            var link = document.createElement('a');
            link.className = 'bulkforce__msg-link';
            link.href = reply.link.href;
            link.textContent = reply.link.label;

            if (reply.link.external) {
                link.target = '_blank';
                link.rel = 'noopener';
            }

            message.appendChild(link);
        }

        log.appendChild(message);
        scrollLog();
    }

    function isOpen() {
        return root.classList.contains('is-open');
    }

    function openPanel() {
        window.clearTimeout(hideTimer);
        panel.hidden = false;
        void panel.offsetHeight;
        root.classList.add('is-open');
        toggle.setAttribute('aria-expanded', 'true');
        pickStatus();

        if (!greeted) {
            greeted = true;
            appendBotMessage(blocked ? BLOCKED_GREETING : GREETING);
        }

        if (!blocked && window.matchMedia('(hover: hover)').matches) {
            input.focus();
        }
    }

    function closePanel(returnFocus) {
        root.classList.remove('is-open');
        toggle.setAttribute('aria-expanded', 'false');
        hideTimer = window.setTimeout(function () {
            panel.hidden = true;
        }, 300);

        if (returnFocus) {
            toggle.focus();
        }
    }

    toggle.addEventListener('click', function () {
        if (isOpen()) {
            closePanel(false);
        } else {
            openPanel();
        }
    });

    if (closeButton) {
        closeButton.addEventListener('click', function () {
            closePanel(true);
        });
    }

    document.addEventListener('keydown', function (event) {
        if (event.key === 'Escape' && isOpen()) {
            closePanel(true);
        }
    });

    form.addEventListener('submit', function (event) {
        event.preventDefault();

        var text = input.value.trim();

        if (!text || replying || blocked) {
            return;
        }

        appendUserMessage(text);
        input.value = '';
        replying = true;

        var reply = window.bulkforceReplies ? window.bulkforceReplies.compose(text) : FALLBACK;

        var typing = document.createElement('div');
        typing.className = 'bulkforce__msg bulkforce__msg--bot bulkforce__typing';

        for (var i = 0; i < 3; i += 1) {
            var dot = document.createElement('span');
            dot.className = 'bulkforce__dot';
            typing.appendChild(dot);
        }

        log.appendChild(typing);
        scrollLog();

        window.setTimeout(function () {
            log.removeChild(typing);
            appendBotMessage(reply);
            replying = false;

            if (reply && reply.block) {
                applyBlockedState();
            }
        }, 700 + Math.floor(Math.random() * 900));
    });

    if (window.bulkforceReplies && window.bulkforceReplies.isBlocked && window.bulkforceReplies.isBlocked()) {
        applyBlockedState();
    }
})();
